<template>
    <el-tooltip content="字号" effect="dark" placement="top">
        <el-popover v-model="visible" placement="bottom" trigger="click" popper-class="font_size">
            <ul class="size-list">
                <li v-for="size in sizes" :key="size" @click="onClick(size)">{{ size }} px</li>
            </ul>
            <section class="upword-wrap" slot="reference">
                <svg-icon icon-class="fontsize" class="upword" />
            </section>
        </el-popover>
    </el-tooltip>
</template>
  
<script>
export default {
    data() {
        return {
            visible: false,
            sizes: [8, 10, 12, 14, 16, 18, 20, 22, 24, 26, 28, 30, 32, 36, 40, 48, 56, 64, 72]
        }
    },
    methods: {
        onClick(e) {
            this.$emit("click", e);
            this.visible = false;
        }
    },
};
</script>
<style scoped lang="scss">
.upword-wrap {
    width: 40px;
    margin: 2px;
    height: 40px;
    display: flex;
    justify-content: center;
    align-items: center;
    border-radius: 50%;
    cursor: pointer;
    transition: all .2s ease-in-out;

    &:hover {
        background-color: #e4e9f2;
    }

    .upword {
        width: 16px;
        height: 16px;
    }
}

.size-list {
    display: flex;
    flex-direction: column;
    padding: 0;
    margin: 0;
    max-height: 200px;
    overflow-y: auto;
    cursor: pointer;

    &::-webkit-scrollbar {
        display: none;
        /* Chrome Safari */
    }

    li {
        width: 80px;
        height: 40px;
        line-height: 40px;
        display: flex;
        justify-content: center;
        align-items: center;
        transition: all .2s ease-in-out;
    }

    li:hover {
        color: #5A96E3;
        background-color: #e4e9f2;
    }
}
</style>
<style>
.font_size {
    padding: 0;
    margin: 0;
    min-width: 0;
}
</style>